import React, { useState } from "react";
import * as XLSX from "xlsx";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import db from "./Firebase"; // adjust path if needed

const UpdateEndDatePage = () => {
    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState([]);

    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setLog([]);

        const reader = new FileReader();
        reader.onload = async (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const parsed = XLSX.utils.sheet_to_json(sheet);

            const phones = parsed.map((row) => String(row.Phone || row.phone)).filter(Boolean);

            const logs = [];

            const chunks = [];
            while (phones.length) chunks.push(phones.splice(0, 10)); // Firestore .in() max 10

            for (let chunk of chunks) {
                const q = query(
                    collection(db, "udhyogini_features"),
                    where("phone", "in", chunk)
                );
                const snap = await getDocs(q);

                for (const docSnap of snap.docs) {
                    const ref = docSnap.ref;
                    try {
                        await updateDoc(ref, {
                            end_date: new Date("2025-12-31T23:59:59.000+05:30"), // 31st Dec 2025 EOD
                        });
                        logs.push(`✅ Updated ${docSnap.data().phone}`);
                    } catch (err) {
                        logs.push(`❌ Failed to update ${docSnap.data().phone}: ${err.message}`);
                    }
                }
            }

            setLog(logs);
            setLoading(false);
        };

        reader.readAsArrayBuffer(file);
    };

    return (
        <div style={{ padding: "2rem" }}>
            <h2>📅 Update End Dates to 31st Dec 2025</h2>
            <input type="file" accept=".xlsx, .xls" onChange={handleExcelUpload} />
            {loading && <p>⏳ Updating Firestore...</p>}
            <ul style={{ marginTop: "1rem" }}>
                {log.map((l, i) => (
                    <li key={i}>{l}</li>
                ))}
            </ul>
        </div>
    );
};

export default UpdateEndDatePage;
